import styled from "@emotion/styled";

export const StyleSubscriptionCard = styled.div<{ status?: string }>`
  border-radius: 6px;
  background-color: ${(props: any) =>
    props.status === "subscribed"
      ? props.theme.subscription.subscribed
      : props.status === "active"
        ? props.theme.subscription.active
        : props.status === "expired"
          ? props.theme.subscription.expired
          : props.theme.subscription.expiring};

  padding: 30px;
  font-size: 14px;
  display: flex;
  justify-content: space-between;
  width: 100%;
`;

export const StyleLeft = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  color: ${(props: any) => props.theme.colors.white};
  gap: 12px;
`;

export const StyleRight = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: start;
`;
